import React from "react";

export const PageHeader = ({ title, subtitle, actions, breadcrumb }) => (
    <div className="mb-5 flex items-start justify-between gap-4 flex-wrap">
        <div>
            {breadcrumb && <div className="text-xs text-muted-foreground mb-1">{breadcrumb}</div>}
            <h1 className="font-display text-2xl font-bold tracking-tight" data-testid="page-title">{title}</h1>
            {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
);

export const Surface = ({ children, className = "", ...props }) => (
    <div className={`surface ${className}`} {...props}>{children}</div>
);

export const Stat = ({ label, value, hint, icon: Icon, tone = "default" }) => (
    <Surface className="p-4">
        <div className="flex items-start justify-between">
            <div>
                <div className="text-xs uppercase tracking-wider text-muted-foreground font-semibold">{label}</div>
                <div className="font-display text-2xl font-bold mt-1 tabular-nums">{value}</div>
                {hint && <div className="text-xs text-muted-foreground mt-1">{hint}</div>}
            </div>
            {Icon && (
                <div className={`size-9 rounded-md flex items-center justify-center ${tone === "primary" ? "bg-primary/10 text-primary" : "bg-secondary text-muted-foreground"}`}>
                    <Icon className="size-5" />
                </div>
            )}
        </div>
    </Surface>
);

export const Empty = ({ title = "No data", subtitle, action }) => (
    <div className="text-center py-12">
        <div className="font-display text-base font-semibold text-foreground">{title}</div>
        {subtitle && <div className="text-sm text-muted-foreground mt-1">{subtitle}</div>}
        {action && <div className="mt-4">{action}</div>}
    </div>
);

export const TableWrap = ({ children }) => (
    <div className="surface overflow-hidden">
        <div className="overflow-auto">
            <table className="w-full dense-table">{children}</table>
        </div>
    </div>
);
